import { ICKLeverantorList } from "./ckLeverantorList";

export class CKLeverantorViewModel {
    constructor(private readonly model: ICKLeverantorList) {
    }

    get id() {
        return this.model.id;
    }

    get namn() {
        return this.model.namn;
    }

    get avdelning() {
        return this.model.avdelning;
    }

    get aktiv() {
        return this.model.aktiv;
    }

    get besokPostortadress() {
        return this.model.besokPostortadress;
    }

    get huvudkod() {
        return this.model.huvudkod;
    }

    get internnummer() {
        return this.model.internnummer;
    }

    get orgNummer() {
        return this.model.orgNummer;
    }

    get ckLeverantorModel(): ICKLeverantorList {
        return this.model;
    }
}
